import Graphic from "@arcgis/core/Graphic";
import { AppConfig } from "../../../AppConfig";
import ObjectTypeButton, { ReplaceOptions } from "./ObjectTypeButton";
import ObjectGroup from "./ObjectGroup";

interface AllObjectTypesPanelProps {
    setActiveLayerId?: (layerId: string) => void;
    setEditMode?: (editMode: boolean) => void;
    setNewFeature?: (feature: Graphic, options?: ReplaceOptions) => void | Promise<void>;
    setPendingLighthouseFeature?: (feature: Graphic | null) => void;
    isReplacing?: boolean;
}

const AllObjectTypesPanel = (props: AllObjectTypesPanelProps) => {
    const { setActiveLayerId, setEditMode, setNewFeature, setPendingLighthouseFeature, isReplacing } = props;

    return (
        <div className="flex-col medium-gap all-objects scrollable">
            {AppConfig.CreateObject.map((objectGroupConfig) => {
                return (
                    <ObjectGroup title={objectGroupConfig.GroupName} key={objectGroupConfig.GroupName}>
                        {objectGroupConfig.GroupEntries.map((groupEntryConfig) => {
                            return (
                                <ObjectTypeButton
                                    key={groupEntryConfig.Title}
                                    title={groupEntryConfig.Title}
                                    layerName={groupEntryConfig.LayerName}
                                    presetAttributes={groupEntryConfig.FieldValues}
                                    setActiveLayerId={setActiveLayerId}
                                    setEditMode={setEditMode}
                                    setNewFeature={setNewFeature}
                                    setPendingLighthouseFeature={setPendingLighthouseFeature}
                                    isReplacing={isReplacing}
                                />
                            );
                        })}
                    </ObjectGroup>
                );
            })}
        </div>
    );
};

export default AllObjectTypesPanel;
